import { IntercomContextValues, useIntercom } from 'react-use-intercom';

const useOpenIntercomService = (): IntercomContextValues => {
  const { ...props } = useIntercom();
  return props;
};

export default useOpenIntercomService;
